import { Skeleton } from "@/components/ui/skeleton"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
interface AppSkeletonTableProps {
  columns: number
  withHeaderButton?: boolean
  withAction?: boolean
}
export const AppSkeletonTable = ({
  columns = 5,
  withHeaderButton = false,
  withAction = false,
}: AppSkeletonTableProps) => {
  const rows = 10
  return (
    <div className="space-y-4">
      {withHeaderButton && (
        <div className="flex items-center justify-end gap-4">
          <Skeleton variant="secondary" className="h-10 min-w-36" />
          {withAction && (
            <Skeleton variant="secondary" className="h-10 min-w-36" />
          )}
        </div>
      )}
      <div className="overflow-hidden rounded-md border border-border">
        <Table>
          <TableHeader>
            <TableRow>
              {Array.from({ length: columns }, (_, i) => (
                <TableHead key={i} className="text-white">
                  <Skeleton variant="secondary" className="h-4 w-16" />
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: rows }, (_, i) => (
              <TableRow key={i}>
                {Array.from({ length: columns }, (_, i) => (
                  <TableCell key={i}>
                    <Skeleton className="h-8 w-full" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-20" variant="secondary" />
        <div className="flex items-center justify-center gap-1 p-4">
          <Skeleton className="size-9" variant="secondary" />
          <Skeleton className="size-9" variant="secondary" />
          <Skeleton className="size-9" variant="secondary" />
          <Skeleton className="size-9" variant="secondary" />
          <Skeleton className="h-9 w-[100px]" variant="secondary" />
        </div>
        <Skeleton className="h-9 w-28" variant="secondary" />
      </div>
    </div>
  )
}
